import { z } from "zod";

const schema = z.object({
  milestone: z.string({
    required_error: "You must select a milestone",
  }),
});

type Schema = z.infer<typeof schema>;

export {
  schema as milestonePaymentFormSchema,
  type Schema as MilestonePaymentFormSchema,
};
